// extracted by mini-css-extract-plugin
export var container = "_cb-1";
export var cornerButtonContainer = "_cb-6";
export var disabled = "_cb-2";
export var dragActive = "_cb-3";
export var fileContainer = "_cb-5";
export var hiddenInput = "_cb-4";
export var widthContainer = "_cb-0";